export const DISTRIBUTION_MODELS = {
  REPURCHASE: 'REPURCHASE',
  ACTIVATION: 'ACTIVATION',
  RECOVERY: 'RECOVERY',
}

export const DISTRIBUTION_MODEL_LABELS = {
  REPURCHASE: 'Recompra',
  ACTIVATION: 'Ativação',
  RECOVERY: 'Resgate',
}

export const DISTRIBUTION_MODEL_DESCRIPTIONS = {
  REPURCHASE: 'Produtos já comprados pelo cliente nos últimos 90 dias.',
  ACTIVATION: 'Produtos em categorias não exploradas pelo cliente.',
  RECOVERY: 'Produtos que o cliente deixou de comprar nos últimos 30 dias.',
}
